<template>
  <section class="schedule-evaluation">
<!--    <b-card class="p-2 mb-1" bg-variant="light-danger" no-body>-->
<!--      <div class="d-flex justify-content-center align-items-center">-->
<!--        <b-button variant="danger" @click="openModal">-->
<!--          <feather-icon size="16" icon="CalendarIcon" class="mr-50" />-->
<!--          <span class="align-middle">{{ manager ? "Modifier la date" : "Suggérer une date" }}</span>-->
<!--        </b-button>-->
<!--      </div>-->
<!--    </b-card>-->

      <div class="d-flex align-items-center">
        <b-button variant="danger" @click="openModal">
          <feather-icon size="16" icon="CalendarIcon" class="mr-50" />
          <span class="align-middle">{{ manager ? "Modifier la date" : "Suggérer une date" }}</span>
        </b-button>
      </div>

    <!-- MODAL DE SÉLECTION -->
    <b-modal
        id="modal-sm"
        v-model="isModalActive"
        modal-class="modal-primary"
        centered
        size="md"
        title="Planification de la date"
        ok-title="Enregistrer"
        cancel-title="Fermer"
        @ok="newDateEvaluation"
    >
      <b-form-group>
        <flat-pickr
          v-model="inlineDate"
          class="form-control"
          :config="flatPickrConfig"
        />
      </b-form-group>
    </b-modal>
  </section>
</template>

<script>
import { BButton, BModal, BFormGroup } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import { French } from "flatpickr/dist/l10n/fr";
import {
  updateDateEvaluationMeeting,
} from "@/services/UserEvaluationService";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { getConfigs } from "@/services/EvaluationIntervalConfigsService";
import { getJsonFromStorage } from "@/util/storageUtils";

export default {
  name: "EvaluationDateScheduler", // Nom du composant
  components: {
    BButton,
    BModal,
    BFormGroup,
    flatPickr,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    currentYear: {
      type: Number,
      required: true,
    },
    manager: {
      type: Boolean,
      required: true,
    },
    userEvaluation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    flatPickrConfig() {

      const today = new Date();

      let minDate = this.evaluationStartDate
          ? moment(this.evaluationStartDate, "DD-MM-YYYY").hour(8).minute(0).second(0).millisecond(0).toDate()
          : today;

      const daysToAdd = this.config;
      let maxDate = this.addBusinessDays(minDate, daysToAdd);

      if (minDate < today) {
        minDate = today;
      }

      const MIN_BUSINESS_DAYS = 5;

      const datePropose = this.userEvaluation?.dateEvaluationPropose
          ? moment(this.userEvaluation.dateEvaluationPropose, "DD-MM-YYYY HH:mm").toDate()
          : this.userEvaluation?.dateEvaluationPrevu
              ? moment(this.userEvaluation.dateEvaluationPrevu, "DD-MM-YYYY HH:mm").toDate()
              : null;

      if (datePropose && datePropose < minDate) {
        minDate = today;
      }


      if (maxDate <= minDate) {
        maxDate = this.addBusinessDays(minDate, MIN_BUSINESS_DAYS);

      } else {
        const businessDaysLeft = this.countBusinessDays(minDate, maxDate);

        if (businessDaysLeft < MIN_BUSINESS_DAYS) {
          maxDate = this.addBusinessDays(maxDate, MIN_BUSINESS_DAYS);
        }
      }

      console.log("Date à charger ! ", this.inlineDate)
      return {
        enableTime: true,
        time_24hr: true,
        enableSeconds: false,
        inline: true,
        altInput: true,
        altFormat: "d-m-Y H:i",
        dateFormat: "d-m-Y H:i",
        minDate: today,
        maxDate,
        locale: French,
        disable: [
          function (date) {
            const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            if (d.getDay() === 0 || d.getDay() === 6) {
              return true;
            }

            if (datePropose && moment(date).isSame(datePropose, 'minute')) {
              return false;
            }

            return d < t;
          }
        ]
      };
    },
  },
  data() {
    return {
      config: 0,
      isModalActive: false,
      inlineDate: this.userEvaluation.dateEvaluationPrevu ? this.userEvaluation.dateEvaluationPrevu : this.userEvaluation.dateEvaluationPropose
    };
  },
  async mounted() {
    await this.getConfigByUser();
  },
  methods: {
    countBusinessDays(start, end) {
      let count = 0;
      const date = new Date(start);

      while (date < end) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (day !== 0 && day !== 6) {
          count++;
        }
      }
      return count;
    },
    addBusinessDays(today, daysToAdd) {
      const date = new Date(today);
      let addedDays = 0;

      if (date.getDay() !== 0 && date.getDay() !== 6) {
        addedDays = 1;
      }

      while (addedDays < daysToAdd) {
        date.setDate(date.getDate() + 1);

        const day = date.getDay();
        if (day !== 0 && day !== 6) {
          addedDays++;
        }
      }

      return date;
    },
    openModal() {
      this.isModalActive = true;
    },
    getStoredUserData() {
      const storedUserData = getJsonFromStorage("userData");
      return storedUserData ? storedUserData : null;
    },
    async getConfigByUser() {
      const userConnected = this.getStoredUserData();
      let id;
      if (this.manager) {
         id = userConnected.id;

      }else {
        id = userConnected.usersHierarchique[0].id
      }

      try {
        const response = await getConfigs(id);
        this.config = response.intervalDays;
      } catch (error) {
        console.error("Error fetching config:", error);
        this.config = 7; // Valeur par défaut en cas d'erreur
      }
    },
    async newDateEvaluation() {
      // Formater la date
      let formattedDate;
      if (this.inlineDate.match(/^\d{2}-\d{2}-\d{2} \d{2}:\d{2}$/)) {
        const [datePart, timePart] = this.inlineDate.split(" ");
        const [day, month, year] = datePart.split("-");
        const fullYear = year.length === 2 ? `20${year}` : year;
        formattedDate = `${day}-${month}-${fullYear} ${timePart}`;
      } else {
        formattedDate = moment(this.inlineDate, "DD-MM-YYYY HH:mm", true).format("DD-MM-YYYY HH:mm");
      }

      // Créer une copie de userEvaluation pour éviter les mutations directes
      const updatedEvaluation = { ...this.userEvaluation };

      try {
        if (!this.manager) {
          // Collaborateur suggère une date
          if (!updatedEvaluation.suggestDate || updatedEvaluation.suggestDate < 2 ) {
            updatedEvaluation.dateEvaluationSuggest = formattedDate;


            const result = await updateDateEvaluationMeeting(updatedEvaluation.idPublic, updatedEvaluation, 'USER_SUGGEST');
            if (result.dateEvaluationSuggest) {
              this.showToast("Date suggérée enregistrée avec succès", "success", "BellIcon");
              // Émettre l'événement pour mettre à jour userEvaluation dans le parent
              this.$emit("update:userEvaluation", result);
            } else {
              this.showToast("Erreur lors de l'enregistrement de la date suggérée", "danger", "BellIcon");
            }
          }else{
            this.showToast("Nombre maximal de suggestions atteint", "danger", "BellIcon");

          }
        } else {
          // Manager propose une date
          if (!updatedEvaluation.proposeDate || updatedEvaluation.proposeDate< 2) {
            if (updatedEvaluation.dateEvaluationPrevu && updatedEvaluation.status === 'MEETING') {
              updatedEvaluation.dateEvaluationPrevu = formattedDate;

            } else {
              updatedEvaluation.dateEvaluationPropose = formattedDate;

            }

            const result = await updateDateEvaluationMeeting(updatedEvaluation.idPublic, updatedEvaluation, 'MANAGER_PROPOSE');
            if (result.dateEvaluationPropose) {
              this.showToast("Date proposée enregistrée avec succès", "success", "BellIcon");
              // Émettre l'événement pour mettre à jour userEvaluation dans le parent
              this.$emit("update:userEvaluation", result);
            } else if (result.dateEvaluationPrevu) {

              this.showToast("Date prévue enregistrée avec succès", "success", "BellIcon");
              // Émettre l'événement pour mettre à jour userEvaluation dans le parent
              this.$emit("update:userEvaluation", result);
            } else {
              this.showToast("Erreur lors de l'enregistrement de la date proposée", "danger", "BellIcon");
            }
          }else{
            this.showToast("Nombre maximal de propositions atteint", "danger", "BellIcon");

          }
        }
      } catch (error) {
        this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
        console.error("Erreur lors de la mise à jour de la date:", error);
      }
    },
    showToast(message, color, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon,
          text: message,
          variant: color,
          timeout: 5000,
        },
      });
    },
  },
};
</script>

<style scoped>
.schedule-evaluation {
  margin: 0 auto;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
